import { LocalStorageFilterDomainIdKey } from 'app/services/domain-filter.service';

export function isRecordInFilteredDomain(record: any, inOnlyFiltered?: boolean): boolean{
	const filteredDomainId = localStorage.getItem(LocalStorageFilterDomainIdKey);
	const isFiltered = filteredDomainId && filteredDomainId !== 'null';
	if(!record.domain) return !isFiltered;
	return (!isFiltered && inOnlyFiltered !== false) || (isFiltered && filteredDomainId === record.domain.id);
}
